import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SecurityService, LoggingService, LoaderService } from '../services';
import { Router } from '@angular/router';
import { TopNotificationService } from 'src/app/shared/components/top-notification/top-notification.service';
import { NotificationType } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable()
export class UnAuthorizedInterceptor implements HttpInterceptor {
  constructor(
    private securityService: SecurityService,
    private loggingService: LoggingService,
    private loaderService: LoaderService,
    private notificationService: TopNotificationService,
    private router : Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      this.loggingService.Error(`Request with URL=${request.url} returned Name=${name}, HttpStatusCode=${err.status}, HttpVerb=${request.method}, Message=${err.message}`);
      if (err.status === 401 && !request.url.includes(environment.masterLogTokenGenerateEndPoint) && !request.url.includes(environment.masterLogEndPoint)) {
       setTimeout(() => {
         this.notificationService.showNotification('Session expired.', NotificationType.Error);
       });
       this.loaderService.showLoader();
       // auto logout if 401 response returned from api
       this.securityService.logout(true);
      }
      return throwError(err);
    }));
  }
}
